import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {HttpUtilsService, QueryParamsModel, QueryResultsModel} from '../_base/crud';
import {AnnotationModel} from '../models/annotation.model';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import { OKResponse } from '../_base/crud/models/query-models/query-results.model';

const API_ANNOTATIONS_URL = `${environment.pathToAPI}/api/v1/annotations`;

@Injectable()
export class AnnotationsService {
    constructor(
        private http: HttpClient,
        private httpUtils: HttpUtilsService) {
    }

    createAnnotation(annotation: AnnotationModel, token?: string | null): Observable<AnnotationModel> {
        const httpHeaders = this.httpUtils.getHTTPHeaders(token);
        return this.http.post<AnnotationModel>(API_ANNOTATIONS_URL, annotation, {headers: httpHeaders});
    }

    createMultipleAnnotations(annotations: AnnotationModel[], options?: { conversationId?: number | null, token?: string | null}): Observable<OKResponse> {
        console.log('AnnotationsService.createAnnotation!');
        const data = {annotations, conversationId: options?.conversationId};
        const httpHeaders = this.httpUtils.getHTTPHeaders(options?.token);
        return this.http.post<OKResponse>(API_ANNOTATIONS_URL + '/create-multiple', data, {headers: httpHeaders});
    }

    findAnnotations(queryParams: QueryParamsModel<AnnotationModel>, token: string | null | undefined): Observable<QueryResultsModel<AnnotationModel>> {
        console.log('AnnotationsService.findAnnotations!');
        const httpHeaders = this.httpUtils.getHTTPHeaders(token);
        return this.http.post(
            API_ANNOTATIONS_URL + '/find',
            queryParams,
            {headers: httpHeaders}
        ).pipe(map<any, QueryResultsModel<AnnotationModel>>((value) => {
            return new QueryResultsModel(value.response, value.response.length, value.isReadStatus, '');
        }));
    }

    updateAnnotation(annotation: AnnotationModel, token?: string | null): Observable<AnnotationModel> {
        const httpHeader = this.httpUtils.getHTTPHeaders(token);
        return this.http.put<AnnotationModel>(API_ANNOTATIONS_URL + `/${annotation.id}`, annotation, {headers: httpHeader});
    }

    deleteAnnotation(annotationId: number): Observable<OKResponse> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        const url = `${API_ANNOTATIONS_URL}/${annotationId}`;
        return this.http.delete<OKResponse>(url, {headers: httpHeaders});
    }

    deleteAnnotations(ids: number[] = [], token?: string | null): Observable<OKResponse> {
        if (ids.length > 0) {
            const url = API_ANNOTATIONS_URL + '/deleteAnnotations';
            const httpHeaders = this.httpUtils.getHTTPHeaders(token);
            const body = {annotationIdsForDelete: ids};
            return this.http.put<OKResponse>(url, body, {headers: httpHeaders});
        }
        return of({ok: false});
    }
}
